import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'antd';

const RoleRestrictionRedirectModal = ({ visible }) => {
  const [countdown, setCountdown] = useState(5);
  const [showRedirectLink, setShowRedirectLink] = useState(false);
  const intervalRef = useRef(null);
  const carePlatformUrl = process.env.NALURI_APP_CARE_PLATFORM || 'https://care.naluri.net';

  useEffect(() => {
    if (!visible) {
      // Clear any existing interval when modal is hidden
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Reset countdown when modal becomes visible
    setCountdown(5);

    // Clear any existing interval before creating a new one
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // Clear interval from ref
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          // Redirect when countdown reaches 0
          if (carePlatformUrl) {
            window.location.href = carePlatformUrl;
          }
          setShowRedirectLink(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Cleanup function
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [visible, carePlatformUrl]);

  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      centered
      width={500}
      maskClosable={false}
    >
      <div style={{ padding: '20px 0' }}>
        <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>Sunset Notice</h3>
        <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0, textAlign: 'center' }}>
          Redirecting you to Naluri Care....
        </p>
        <p style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px', textAlign: 'center' }}>
          {countdown}
        </p>
      {
        showRedirectLink && (
          <p>
            If you are not redirected automatically, please click <a href={carePlatformUrl} target="_blank" rel="noopener noreferrer">here</a> to continue.
          </p>
        )
      }       
      </div>
    </Modal>
  );
};

export default RoleRestrictionRedirectModal;


// WEBPACK FOOTER //
// ./src/features/common/RoleRestrictionRedirectModal.js